import React, { useCallback, useState } from 'react';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { NoIcon } from '../../concepts/resources/Icon';
import { Menu } from '../../ui';
import { Crumbs } from '../common/Crumbs';
import { usePermissionCheck } from '../common/PermissionElements';
import { useResolve } from '../Container';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { workspaceImportLegacy } from '../workspace/WorkspaceCommands';

export const AllBoardsMenu = () => {

    const dispatch = useResolve(CommandDispatcher);
    const canImport = usePermissionCheck('da:write');

    const [open, setOpen] = useState(false);
    const close = () => {
        setOpen(false);
        return true;
    };

    const onImportLegacy = useCallback(() => void (close() && dispatch(workspaceImportLegacy)), []);

    return <Crumbs>
        {canImport && <Crumbs.Menu label="All Boards" open={open} setOpen={setOpen}>
            <Flexer minWidth="12">
                <Menu>
                    <Menu.Item onClick={onImportLegacy}>
                        <NoIcon size="1.2" />
                        <Menu.ItemText>
                            Import Legacy Boards
                        </Menu.ItemText>
                    </Menu.Item>
                </Menu>
            </Flexer>
        </Crumbs.Menu>}
        {!canImport &&
            <Crumbs.Title>All Boards</Crumbs.Title>
        }
    </Crumbs>;
};
